import React from 'react';
import logoMain from '../assets/logo-main.png';

const PoweredByBlockBoard: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-2 py-6 ${className}`}>
    <span className="text-xs text-white/40">Powered by</span>
    <img src={logoMain} alt="BlockBoard" className="h-4 opacity-60" />
  </div>
);

export default PoweredByBlockBoard;
